import React from 'react';
import Section from '../components/Section';
import Container from '../components/Container';
import SectionTitle from '../components/SectionTitle';
import { useClients } from '../data';

/*
 * §Homepage — "Our Clients" between Services and Contact. An engineering-themed,
 * logo-centric showcase: two infinite rows scrolling in opposite directions over
 * a faint blueprint grid. Each client is a uniform "blueprint plate" — logos sit
 * as a white silhouette and reveal their full colour on a light spotlight hover.
 * Fully data-driven (clients collection); upload PNG logos via the admin.
 */
function Plate({ c, dim }) {
  return (
    <div className="client-plate" aria-hidden={dim}>
      <span className="client-plate__tick" aria-hidden="true" />
      <span className="client-plate__tick client-plate__tick--br" aria-hidden="true" />
      {c.logo ? (
        <img className="client-plate__logo" src={c.logo} alt={c.name} loading="lazy" />
      ) : (
        <span className="client-plate__name">{c.name}</span>
      )}
    </div>
  );
}

function Row({ items, reverse }) {
  if (!items.length) return null;
  const loop = [...items, ...items];
  const dur = `${Math.max(22, items.length * 6)}s`;
  return (
    <div className={`clients__row${reverse ? ' clients__row--rev' : ''}`}>
      <div className="clients__track" style={{ '--marquee-dur': dur }}>
        {loop.map((c, i) => (
          <Plate key={`${c.id}-${i}`} c={c} dim={i >= items.length} />
        ))}
      </div>
    </div>
  );
}

export default function ClientsSection() {
  const clients = (useClients() || []).slice().sort((a, b) => a.order - b.order);
  if (!clients.length) return null;

  const half = Math.ceil(clients.length / 2);
  const rowA = clients.slice(0, half);
  const rowB = clients.slice(half);

  return (
    <Section className="clients" contained={false}>
      <div className="clients__bg" aria-hidden="true" />
      <Container className="clients__head">
        <p className="clients__eyebrow">Trusted partners</p>
        <SectionTitle white="Our" accent="Clients" />
        <p className="clients__intro">
          Trusted by leading energy companies, infrastructure firms, municipalities, and economic
          corporations across Israel.
        </p>
      </Container>

      <div className="clients__rows">
        <Row items={rowA} />
        <Row items={rowB.length ? rowB : rowA} reverse />
      </div>
    </Section>
  );
}
